import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { UserService } from '../../../@domain/user/application/user.service';
import { AppRoute } from '../../../routing/types/app-route';
import { BreadcrumbComponent } from '../../../@ui/app/global/breadcrumb/breadcrumb.component';

@Component({
    selector: 'app-profile-dashboard',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        RouterLink,
        RouterOutlet,
        BreadcrumbComponent,
    ],
    styles: `
        @use "variables" as *;
        @use "functions" as *;

        :host {
            width: 100%;
            display: flex;
            flex-direction: column;
            flex: 1;
            padding-top: 45px;

            @include break(768px) {
                padding-top: 25px;
            }
        }

        .top-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 1rem;
            margin-bottom: 25px;

            ::ng-deep app-breadcrumb {
                flex: 1;
                margin-bottom: 0;
                min-width: 0;
            }
        }

        .username {
            font-size: 2.2rem;
            font-weight: 700;
            color: $dark-blue;
            text-transform: uppercase;
            margin-bottom: 30px;

            @include break(768px) {
                font-size: 1.5rem;
            }
        }

        .edit-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            font-weight: 600;
            color: $dark-blue;
            background-color: $light-blue;
            border-radius: 4px !important;
            text-decoration: none;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            white-space: nowrap;
            padding: 12px 15px;
            flex-shrink: 0;
            transition: background 0.2s, color 0.2s;

            &:hover {
                background: $dark-blue;
                color: $white;
            }

            @include break(768px) {
                font-size: 11px;
                padding: 8px 10px;
            }
        }
    `,
    template: `
        <div class="container">
            <div class="top-row">
                <app-breadcrumb
                    [breadcrumbItems]="[{label: 'HOME', link: '/'}, {label: userName()}]"/>
                <a class="edit-btn" routerLink="/{{ AppRoutes.Profile }}/edit">EDIT PROFILE</a>
            </div>

            <h1 class="username">{{ userName() }}</h1>

            <router-outlet/>
        </div>
    `
})
export default class ProfilePage {
    private userService = inject(UserService);

    public AppRoutes = AppRoute;
    public user = this.userService.user;
    public userName = computed(() => {
        const u = this.user();
        if (!u) return '';
        return `${u.first_name} ${u.last_name}`.trim() || u.username || '';
    });
}
